<div class="reviews-container" *ngIf="reviews.length">
  <div class="review-card" *ngFor="let r of reviews">
    <strong>{{ r.author_Name | titlecase }}</strong>
      <div>
        <div class="stars">
          <span *ngFor="let s of [1,2,3,4,5]" [class.filled]="s <= r.rating">★</span>
        </div>
      </div>
    <p>{{ r.text }}</p>
    <small>{{ r.relative_Time_Description }}</small>
  </div>
</div>
